import { createSlice } from '@reduxjs/toolkit'
import { createAsyncThunk } from '@reduxjs/toolkit'
import InstructionService from 'services/InstructionService'

export const initialState = {
    instructionList: {
        data: [],
        isLoading: false,
        error: false,
        success: false
    },
    instructionAdd: {
        data: [],
        isLoading: false,
        error: false,
        success: false
    },
    instructionDelete: {
        data: [],
        isLoading: false,
        error: false,
        success: false
    },
}

export const fetchInstructionListDynamic = createAsyncThunk(
    'instruction/getInstructionListDynamic',
    async (data, { rejectWithValue }) => {
        try {
            console.log('slice')
            const response = await InstructionService.getInstructionsListDynamic(data)
            return response.data
        } catch (err) {
            return rejectWithValue(err.response?.data?.message || 'Error')
        }
    }
)

export const addInstruction = createAsyncThunk('instruction/addInstruction', async (data, { rejectWithValue }) => {
    try {
        console.log(data)
        const response = await InstructionService.addInstruction(data)
        return [response]
    } catch (err) {
        return rejectWithValue(err.response?.data?.message || 'Error')
    }
})


export const deleteInstruction = createAsyncThunk(
    'instruction/deleteInstruction',
    async (params, { rejectWithValue }) => {
        try {
            await InstructionService.deleteInstruction(params)
            return params
        } catch (err) {
            return rejectWithValue(err.response?.data?.error || 'Error')
        }
    }
)

export const instructionSlice = createSlice({
    name: 'instruction',
    initialState,
    reducers: {},
    extraReducers(builder) {
        builder
            .addCase(fetchInstructionListDynamic.pending, (state, action) => {
                state.instructionList.isLoading = true
            })
            .addCase(fetchInstructionListDynamic.rejected, (state, action) => {
                state.instructionList.isLoading = false
                state.instructionList.error = action.error.message
            })
            .addCase(fetchInstructionListDynamic.fulfilled, (state, action) => {
                state.instructionList.isLoading = false
                state.instructionList.error = false
                state.instructionList.data = action.payload
            })

            .addCase(addInstruction.pending, (state, action) => {
                state.instructionAdd.isLoading = true
            })
            .addCase(addInstruction.rejected, (state, action) => {
                state.instructionAdd.isLoading = false
                state.instructionAdd.error = action.error.message
            })
            .addCase(addInstruction.fulfilled, (state, action) => {
                state.instructionAdd.isLoading = false
                state.instructionAdd.error = false
                state.instructionAdd.data = action.payload
                state.instructionAdd.success = true
            })
    },
})

export default instructionSlice.reducer
